import StatusPill from "./StatusPill";

export default function ViewApplication() {
  return (
    <div className="space-y-6 font-inter">
      {/* ================= COURSE SUMMARY CARD ================= */}
      <div className="rounded-2xl border border-[#FDCBFD] bg-[#FDF3FD]  flex justify-between gap-6">
        <div className="p-6 flex-1">
          <h3 className="text-lg font-bold mb-3 text-black font-inter">
            Master Of Science In Data Science & Artificial Intelligence
          </h3>
          <p className="font-xl font-bold text-[#3F424C] my-3">
            Deakin University
          </p>
          <div className="flex flex-wrap gap-6 text-sm">
            {/* <Info label="University" value="Deakin University" /> */}
            <Info label="Campus" value="Downtown Montreal" />
            <Info label="Duration" value="4 years" />
            <Info label="Intake" value="March 2021" />
            <Info label="Course Level" value="Masters" />
          </div>
        </div>

        {/* Decorative image placeholder */}
        <div className="hidden md:block  ">
          <img src="/applicationDetails.png" alt="AD" className="w-68 h-58" />
        </div>
      </div>

      {/* ================= COURSE FIELD ================= */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SmallCard
          title="Course Broad Field"
          value="Engineering & Related Technologies"
        />
        <SmallCard title="Course Narrow Field" value="Civil Engineering" />
      </div>

      {/* ================= COURSE PREFERENCE ================= */}
      <Section title="Course Preference">
        <table className="w-full text-sm border-collapse border border-[#BAAE9C] rounded-xl">
          <thead className="bg-[#FFF5E6] border-b border-[#BAAE9C]">
            <tr>
              <th className="px-4 py-3 text-left">Campus</th>
              <th className="px-4 py-3 text-left">Courses</th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4].map((i) => (
              <tr key={i} className="border-b last:border-none">
                <td className="px-4 py-3">Geelong Waurn Ponds Campus</td>
                <td className="px-4 py-3">
                  Master Of Science In Data Science & Artificial Intelligence
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>

      {/* ================= APPLICATION MODE ================= */}
      <Section title="Application Mode Information (University Submission)">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-sm">
          <Info label="Submission Date" value="05-03-2020" />
          <Info label="Course Preference For" value="Sent Via Portal" />
          <Info label="Portal Name" value="SIEC" />
          <Info
            label="Acknowledgment Status"
            value={<StatusPill text="Pending" />}
          />
          <Info label="Acknowledgment Number" value="-" />
          <Info
            label="Acknowledgment Letter"
            value={
              <div className="flex gap-2">
                <img
                  src="/ApplicationsDownload.png"
                  alt="ad"
                  className="h-6 w-6"
                />
                <img src="/View.png" alt="view" className="h-6 w-6" />
              </div>
            }
          />
        </div>
      </Section>

      {/* ================= OFFER STAGE ================= */}
      <Section title="Offer Stage">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-sm mb-6">
          <Info label="Offer Status" value="Conditional Offer Received" />
          <Info
            label="Acknowledgment Status"
            value="Geelong Waurn Ponds campus (BEng Hons)"
          />
          <Info label="Course Fees Currency" value="AUD" />
          <Info label="Conditional Offer Date" value="05-03-2020" />
          <Info label="Lapse Date of Conditional Offer" value="05-03-2020" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-sm">
          <Info label="Annual Tuition Fees AUD" value="808080.00" />
          <Info label="Annual Tuition Fees INR" value="2604150" />
          <Info label="OSHC Fees" value="0.00" />
          <Info label="Total Fees AUD" value="908899.00" />
          <Info label="Total Fees INR" value="-" />
          <Info
            label="Specify conditions for conditional offer"
            value="English Requirement"
          />
          <Info
            label="Conditional Offer"
            value={
              <div className="flex gap-2">
                <img
                  src="/ApplicationsDownload.png"
                  alt="ad"
                  className="h-6 w-6"
                />
                <img src="/View.png" alt="view" className="h-6 w-6" />
              </div>
            }
          />
        </div>
      </Section>

      {/* ================= OFFER ACCEPTANCE ================= */}
      <Section title="Offer Acceptance Stage">
        <p className="text-sm text-gray-500 mb-3">
          Select Your Offer Acceptance Status
        </p>

        <div className="flex gap-6 text-sm mb-6">
          <Radio label="Accept Offer" checked />
          <Radio label="Defer" />
          <Radio label="Withdraw" />
        </div>
        <Section title="Withdraw Information">
          <div className="flex justify-between items-end gap-4">
            <div>
              <p className="text-sm text-gray-500 mb-1">Reason For Withdraw</p>
              <select className="border rounded-lg px-3 py-2 text-sm w-56">
                <option>Plan Drop</option>
              </select>
            </div>

            <button className="bg-[#3B035E] text-white px-6 py-2 rounded-lg text-sm font-medium">
              Save Information
            </button>
          </div>
        </Section>
      </Section>
    </div>
  );
}

/* ================= LOCAL HELPERS ================= */

const Section = ({ title, children }) => (
  <div className="border rounded-2xl bg-white p-6">
    <h4 className="font-bold text-md text-black font-inter mb-4">{title}</h4>
    {children}
  </div>
);

const Info = ({ label, value }) => (
  <div className="bg-white p-2 rounded-lg">
    <p className="text-xs text-gray-500 mb-1">{label}</p>
    <p className="font-xl font-bold text-gray-800">{value}</p>
  </div>
);

const SmallCard = ({ title, value }) => (
  <div className="border rounded-xl p-4 bg-white flex gap-3 items-start">
    <img src="/Courses.png" alt="cources" className=" h-9 w-9" />
    <div>
      <p className="text-xs text-[#161719]">{title}</p>
      <p className="font-semibold text-sm text-[#161719]">{value}</p>
    </div>
  </div>
);

const Radio = ({ label, checked }) => (
  <label className="flex items-center gap-2">
    <input type="radio" checked={checked} readOnly />
    {label}
  </label>
);

const IconBtn = () => (
  <button className="w-8 h-8 flex items-center justify-center border rounded-lg text-[#5B2D8B]">
    ⬇
  </button>
);
